// UpdateSKUModal.styles.ts
import styled from "styled-components";
import { ate } from "../../../global/breakpoints";

// ===== INTERFACE DO TEMA =====
interface Theme {
  colors: {
    background: string;
    text: string;
    selection: string;
    modalColor: string;
    border: string;
    primary?: string;
    danger?: string;
    selectionDark?: string;
    textOnPrimary?: string;
    label?: string;
    borderColor?: string;
  };
}

// ===== COMPONENTES DE MODAL =====
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  opacity: 0;
  animation: fadeIn 0.3s ease forwards;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* A gaveta encosta no pe' da tela: o alinhamento deixa de ser central. */
  ${ate.tablet} {
    align-items: flex-end;
  }
`;

export const ModalContent = styled.div<{ large?: boolean; medium?: boolean }>`
  background: ${(props) => props.theme.colors.modalColor || "#fff"};
  padding: var(--sp-24);
  border-radius: 12px;
  width: ${(props) => (props.large ? "95%" : props.medium ? "80%" : "60%")};
  max-width: ${(props) =>
    props.large ? "calc(var(--u) * 1400)" : props.medium ? "calc(var(--u) * 1000)" : "calc(var(--u) * 800)"};
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.2);
  transform: translateY(-20px);
  animation: slideIn 0.3s ease forwards;

  @keyframes slideIn {
    from {
      transform: translateY(-20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  /*
   * NO CELULAR ESTA CAIXA VIRA GAVETA — e nao e' preferencia, e' conserto.
   *
   * Com "width: 60%" um modal normal tem 225px num telefone de 375: dois
   * campos lado a lado nao cabem, e o titulo quebra em cinco linhas. O
   * "large" (95%) chega perto da largura toda mas continua centrado na
   * vertical, com as bordas arredondadas cortadas pelo topo e pelo pe' da
   * tela.
   *
   * A gaveta de baixo resolve os dois: ocupa a largura inteira, encosta no pe'
   * da tela (que e' onde o polegar esta') e so' arredonda em cima, que e' a
   * unica borda que aparece.
   *
   * O 100dvh CONTRA 100vh, que veio de um defeito MEDIDO no FlyOps.
   *
   * Relato da operacao la', em 24/08/2026: "nao consigo clicar na renuncia do
   * seguro flex no mobile, nao deixa puxar mais". A gaveta usava 100vh — e no
   * celular 100vh e' a viewport GRANDE, a que inclui a faixa coberta pela
   * barra do navegador. A gaveta ficava mais alta que a area visivel, o rodape
   * grudava no fim dela (fora da tela) e a rolagem interna terminava sem nunca
   * revelar os botoes. O 100dvh acompanha a altura realmente visivel.
   *
   * Aqui o vh de cima e' "max-height: 90vh", com o mesmo defeito: os botoes de
   * Salvar e Cancelar caem atras da barra do navegador. Sao 92dvh porque a
   * sobra de 8% mostra o escuro do overlay em cima e deixa claro que da' para
   * fechar tocando fora.
   *
   * NADA DISTO MUDA A TELA GRANDE. A trava do gabarito visual exige diferenca
   * ZERO em 1440px, e uma media query de max-width 768 nunca chega la'.
   */
  ${ate.tablet} {
    width: 100%;
    max-width: 100%;
    max-height: 92dvh;
    margin-top: auto;
    padding: var(--sp-16);
    border-radius: 16px 16px 0 0;
    animation: subirGaveta 0.28s ease forwards;
  }

  @keyframes subirGaveta {
    from {
      transform: translateY(24px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: var(--fs-xl);
  font-weight: bold;
  padding-bottom: var(--sp-16);
  border-bottom: 1px solid
    ${(props) => props.theme.colors.borderColor || "#e0e0e0"};

  /*
   * Grudado no topo da gaveta. Numa gaveta que rola, o titulo e o X somem
   * assim que a pessoa desce dois campos — e sem o X visivel o unico jeito de
   * sair passa a ser rolar de volta ate' em cima.
   *
   * O fundo opaco e' obrigatorio: sem ele o conteudo passa POR TRAS do titulo
   * e as duas camadas de texto se sobrepoem.
   */
  ${ate.tablet} {
    position: sticky;
    top: calc(var(--sp-16) * -1);
    z-index: 2;
    margin: calc(var(--sp-16) * -1) calc(var(--sp-16) * -1) 0;
    padding: var(--sp-16);
    background: ${(props) => props.theme.colors.modalColor || "#fff"};
  }
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: row;
  max-height: calc(var(--u) * 600);
  flex: 1;
  overflow: hidden;

  /*
   * TRES CONSERTOS NUMA REGRA SO', e o do meio e' o grave.
   *
   * 1. "flex-direction: row" poe as colunas lado a lado. Num telefone cada
   *    uma fica com metade de 375px, e o formulario vira uma coluna de
   *    palavras cortadas. Em coluna, cada bloco usa a largura toda.
   *
   * 2. "overflow: hidden" com altura limitada NAO ESCONDE: ELIMINA. O que
   *    passa do corte nao aparece e nao tem barra de rolagem para alcancar —
   *    num modal alto, os ultimos campos simplesmente nao existem para quem
   *    esta' no celular. O auto devolve a rolagem.
   *
   * 3. O teto de 600u e' desenho de tela grande. Na gaveta quem manda na
   *    altura e' a propria gaveta (92dvh), entao ele sai.
   */
  ${ate.tablet} {
    flex-direction: column;
    max-height: none;
    overflow-y: auto;
    overflow-x: hidden;
    overscroll-behavior: contain;
  }
`;

export const ModalTitle = styled.h2`
  display: flex;
  align-items: center;
  gap: var(--sp-12);
  font-size: var(--fs-2xl);
  font-weight: 600;
  color: ${(props) => props.theme.colors.selection};
  margin: 0;
  text-shadow: -0.5px -0.5px 0.5px black, 0.5px -0.5px 0.5px black,
    -0.5px 0.5px 0.5px black, 0.5px 0.5px 0.5px black;
`;

export const ModalCloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${(props) => props.theme.colors.selection};
  font-size: var(--fs-2xl);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--sp-8);
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${(props) => props.theme.colors.selection + "20"};
  }
`;

export const ModalFooter = styled.div`
  padding-top: var(--sp-20);
  border-top: 1px solid ${(props) => props.theme.colors.border};
  margin-top: auto;

  /*
   * Grudado no pe' da gaveta, pelo mesmo motivo do cabecalho: sao os botoes de
   * Salvar e Cancelar. Um formulario longo empurrava os dois para fora da
   * area visivel, e a pessoa rolava sem saber que havia botao.
   *
   * Fundo opaco, sem transparencia: o rodape fica por cima de conteudo denso
   * (tabelas, listas), e translucido ali confunde em vez de enfeitar.
   */
  ${ate.tablet} {
    position: sticky;
    bottom: calc(var(--sp-16) * -1);
    z-index: 2;
    margin: 0 calc(var(--sp-16) * -1) calc(var(--sp-16) * -1);
    padding: var(--sp-12) var(--sp-16)
      calc(var(--sp-12) + env(safe-area-inset-bottom, 0px));
    background: ${(props) => props.theme.colors.modalColor || "#fff"};
  }
`;

// ===== COMPONENTES DE FORMULÁRIO =====
export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sp-24);
  flex: 1;
  overflow-y: auto;
  padding: var(--sp-16);
`;

export const FormSection = styled.div`
  background: ${(props) => props.theme.colors.background + "40"};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 8px;
  padding: var(--sp-20);
  margin-bottom: var(--sp-16);
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(calc(var(--u) * 250), 1fr));
  gap: var(--sp-16);
  margin-bottom: var(--sp-16);
`;

export const FormRow = styled.div`
  display: flex;
  gap: var(--sp-16);
  align-items: flex-start;
  flex-wrap: wrap;
`;

export const SectionTitle = styled.h3`
  font-size: var(--fs-xl);
  font-weight: 600;
  color: ${(props) => props.theme.colors.selection};
  margin: 0 0 var(--sp-16) 0;
  text-shadow: -0.5px -0.5px 0.5px black, 0.5px -0.5px 0.5px black,
    -0.5px 0.5px 0.5px black, 0.5px 0.5px 0.5px black;
`;

// ===== COMPONENTES DE CHECKBOX =====
export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--sp-8);
  padding: var(--sp-8) 0;
`;

export const CheckboxInput = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;

  input[type="checkbox"] {
    opacity: 0;
    position: absolute;
    cursor: pointer;
  }

  .checkmark {
    width: calc(var(--u) * 20);
    height: calc(var(--u) * 20);
    border: 2px solid ${(props) => props.theme.colors.selection};
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    background: ${(props) => props.theme.colors.background};
  }

  input[type="checkbox"]:checked + .checkmark {
    background-color: ${(props) => props.theme.colors.selection};
    border-color: ${(props) => props.theme.colors.selection};
  }

  input[type="checkbox"]:checked + .checkmark::after {
    content: "✓";
    color: white;
    font-size: var(--fs-md);
    font-weight: bold;
  }

  input[type="checkbox"]:focus + .checkmark {
    box-shadow: 0 0 0 2px ${(props) => props.theme.colors.selection + "40"};
  }
`;

export const CheckboxLabel = styled.span<{ active?: boolean }>`
  display: flex;
  align-items: center;
  gap: var(--sp-8);
  font-size: var(--fs-md);
  color: ${(props) => props.theme.colors.text};
  cursor: pointer;
  font-weight: ${(props) => (props.active ? "600" : "400")};

  .tooltip {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    left: 0;
    top: 100%;
    background-color: #333;
    color: white;
    text-align: center;
    border-radius: 8px;
    padding: var(--sp-8) var(--sp-12);
    font-size: var(--fs-md);
    white-space: nowrap;
    z-index: 100;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
    transform: translateY(5px);
  }
`;

// ===== COMPONENTES DE INPUT =====
export const TextInput = styled.div`
  /*
   * O CAMPO NAO E' PINTADO COM A TINTA — e' o contrario: fundo claro, tinta na
   * borda e no texto.
   *
   * Ele JA' FOI pintado, e por minha causa. Quando a paleta do sistema de
   * design entrou, "colors.selection" deixou de ser o azul claro do rosto do
   * icone (#88DBFE) e passou a ser a TINTA (#0976C4), azul cheio. As duas
   * coisas se chamam igual nesta base — "selection" aparece em 520 lugares,
   * 124 como fundo e 114 como texto — entao trocar o VALOR consertou o texto e
   * arrebentou os campos: viraram retangulos azuis escuros com rotulo PRETO
   * por cima.
   *
   * Medido no navegador, num modal so': 36 elementos com esse fundo, 32 abaixo
   * do minimo de contraste. O pior era 1,21:1 — o texto de dica do select, que
   * na pratica sumia.
   *
   * Aqui o papel de cada um volta ao lugar: o fundo do campo e' a superficie da
   * pagina, a tinta fica na BORDA (passa no 1.4.11 com folga) e o rotulo usa a
   * cor de texto do TEMA em vez de "black" fixo — que era outro defeito
   * escondido, porque no tema escuro preto sobre escuro nao aparece.
   *
   * O botao primario continua com fundo "selection": la' o texto e' branco, e
   * com a tinta ele MELHOROU (era 1,7:1 com o azul claro, agora e' 4,9:1).
   */
  padding: var(--sp-10);
  margin-left: var(--sp-10);
  position: relative;
  width: 100%;

  input {
    width: 100%;
    padding: var(--sp-8);
    border: 1.5px solid ${(props) => props.theme.colors.selection};
    border-radius: 4px;
    outline: none;
    background: ${(props) => props.theme.colors.background};
    /* Sem esta linha o campo herda o preto padrao do navegador: no tema escuro
       isso e' preto sobre #252525, medido em 1,37:1 — o que a pessoa digita
       fica invisivel. */
    color: ${(props) => props.theme.colors.text};
  }

  label {
    position: absolute;
    top: 50%;
    left: calc(var(--u) * 20);
    transform: translateY(-50%);
    background: ${(props) => props.theme.colors.background};
    color: ${(props) => props.theme.colors.text};
    padding: 0 var(--sp-5);
    transition: all 0.1s ease-in-out;
    cursor: help;
    display: flex;
    align-items: center;
  }

  .tooltip {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    top: calc(var(--u) * 10);
    left: 0;
    font-weight: bold;
    background-color: #333;
    color: white;
    text-align: center;
    border-radius: 8px;
    padding: var(--sp-8) var(--sp-12);
    font-size: var(--fs-md);
    white-space: nowrap;
    z-index: 100;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  label:hover + .tooltip {
    visibility: visible;
    opacity: 1;
    transform: translateY(0);
  }

  input:focus ~ label,
  input:not(:placeholder-shown) ~ label {
    border-radius: 10px;
    top: calc(var(--u) * 20);
    left: calc(var(--u) * 30);
    transform: scale(1.1) translateY(-100%);
  }

  input:focus {
    background-color: ${(props) => props.theme.colors.primary};
  }
`;

export const DropdownInput = styled.div`
  padding: var(--sp-10);
  margin-left: var(--sp-10);
  position: relative;
  width: 100%;

  select {
    width: 100%;
    padding: var(--sp-8);
    border: 1.5px solid ${(props) => props.theme.colors.selection};
    border-radius: 4px;
    outline: none;
    background: ${(props) => props.theme.colors.background};
    /* Sem esta linha o campo herda o preto padrao do navegador: no tema escuro
       isso e' preto sobre #252525, medido em 1,37:1 — o que a pessoa digita
       fica invisivel. */
    color: ${(props) => props.theme.colors.text};
    cursor: pointer;
  }

  label {
    position: absolute;
    top: 50%;
    left: calc(var(--u) * 15);
    transform: translateY(-50%);
    background: ${(props) => props.theme.colors.background};
    color: ${(props) => props.theme.colors.text};
    padding: 0 var(--sp-5);
    transition: all 0.1s ease-in-out;
    cursor: help;
    display: flex;
    align-items: center;
    pointer-events: none;
  }

  .tooltip {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    top: calc(var(--u) * 10);
    left: 0;
    font-weight: bold;
    background-color: #333;
    color: white;
    text-align: center;
    border-radius: 8px;
    padding: var(--sp-8) var(--sp-12);
    font-size: var(--fs-md);
    white-space: nowrap;
    z-index: 100;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  label:hover + .tooltip {
    visibility: visible;
    opacity: 1;
    transform: translateY(0);
  }

  select:focus ~ label,
  select:valid ~ label {
    border-radius: 10px;
    top: calc(var(--u) * 20);
    left: calc(var(--u) * 30);
    transform: scale(1.1) translateY(-100%);
  }

  select:invalid {
    /* Era "gray" (#808080): 3,74:1 sobre o creme da pagina, medido — abaixo do
       minimo. O carvao-2 do sistema de design faz o mesmo trabalho de "isto e'
       so' a dica, nao um valor escolhido" e chega a 6,5:1. */
    color: ${(props) => props.theme.colors.label};
  }
`;

export const TextArea = styled.div<{ fullWidth?: boolean }>`
  position: relative;
  width: ${(props) => (props.fullWidth ? "100%" : "auto")};

  textarea {
    width: 100%;
    padding: var(--sp-12);
    border: 1.5px solid ${(props) => props.theme.colors.selection};
    border-radius: 8px;
    outline: none;
    background: ${(props) => props.theme.colors.selection + "20"};
    resize: vertical;
    font-family: inherit;
    font-size: var(--fs-md);
    transition: all 0.2s ease;

    &:focus {
      background-color: ${(props) =>
        (props.theme.colors.primary || props.theme.colors.selection) + "20"};
      border-color: ${(props) => props.theme.colors.selection};
      box-shadow: 0 0 0 2px ${(props) => props.theme.colors.selection + "40"};
    }
  }

  label {
    position: absolute;
    top: calc(var(--u) * -8);
    left: calc(var(--u) * 12);
    background: ${(props) => props.theme.colors.modalColor};
    color: ${(props) => props.theme.colors.text};
    padding: 0 var(--sp-8);
    font-size: var(--fs-xs);
    font-weight: 600;
  }
`;

// ===== COMPONENTES DE BOTÃO =====
export const ButtonGroup = styled.div`
  display: flex;
  gap: var(--sp-12);
  justify-content: flex-end;
  flex-wrap: wrap;
`;

export const PrimaryButton = styled.button`
  display: flex;
  align-items: center;
  gap: var(--sp-8);
  padding: var(--sp-12) var(--sp-24);
  background-color: ${(props) => props.theme.colors.selection};
  color: ${(props) => props.theme.colors.textOnPrimary};
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: var(--fs-md);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background-color: ${(props) => props.theme.colors.selectionDark};
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SecondaryButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--sp-12) var(--sp-24);
  background-color: #f5f5f5;
  color: #333;
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  cursor: pointer;
  font-size: var(--fs-md);
  font-weight: 500;
  transition: background-color 0.2s, transform 0.2s;
  gap: var(--sp-8);

  &:hover {
    background-color: #e8e8e8;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

// ===== COMPONENTES DE ÍCONES =====
export const MaterialIcons = styled.span`
  font-family: "Material Icons";
  font-weight: normal;
  font-style: normal;
  font-size: var(--fs-xl);
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

// ===== COMPONENTES DE BADGE =====
export const InfoBadge = styled.div<{
  type?: "info" | "success" | "warning" | "error";
}>`
  display: inline-flex;
  align-items: center;
  gap: var(--sp-6);
  padding: var(--sp-4) var(--sp-8);
  background-color: ${(props) => {
    switch (props.type) {
      case "success":
        return "#E8F5E8";
      case "warning":
        return "#FFF3E0";
      case "error":
        return "#FFEBEE";
      default:
        return "#E3F2FD";
    }
  }};
  color: ${(props) => {
    switch (props.type) {
      case "success":
        return "#2E7D32";
      case "warning":
        return "#E65100";
      case "error":
        return "#C62828";
      default:
        return "#1565C0";
    }
  }};
  border: 1px solid
    ${(props) => {
      switch (props.type) {
        case "success":
          return "#4CAF50";
        case "warning":
          return "#FF9800";
        case "error":
          return "#F44336";
        default:
          return "#2196F3";
      }
    }};
  border-radius: 12px;
  font-size: var(--fs-xs);
  font-weight: 500;
`;

// ===== COMPONENTES DE PREVIEW DE MOEDA =====
export const CurrencyPreview = styled.span`
  font-size: var(--fs-xs);
  color: ${(props) => props.theme.colors.label};
  margin-top: var(--sp-4);
`;

// Exportação padrão para compatibilidade
export default {
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormContainer,
  FormSection,
  SectionTitle,
  FormRow,
  CheckboxContainer,
  CheckboxInput,
  CheckboxLabel,
  InfoBadge,
  FormGrid,
  TextInput,
  DropdownInput,
  TextArea,
  ButtonGroup,
  SecondaryButton,
  PrimaryButton,
  MaterialIcons,
  CurrencyPreview,
};
